import { render } from "./HpEvents.vue?vue&type=template&id=3532bebd"
import script from "./HpEvents.vue?vue&type=script&lang=js"
export * from "./HpEvents.vue?vue&type=script&lang=js"

import exportComponent from "D:\\dev_storage\\webs\\tc_web\\web\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__